<template>
  <div>
    <el-card style="margin-bottom: 12px;">
      <div style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap;">
        <el-select
          v-model="selectedUserId"
          placeholder="篩選用戶（全部）"
          clearable
          filterable
          size="small"
          style="width: 260px;"
          @change="onFilterChange"
        >
          <el-option
            v-for="u in clientList"
            :key="u._id"
            :label="`${u.name || ''} (${u.email})`"
            :value="u._id"
          />
        </el-select>
        <el-select
          v-model="limit"
          size="small"
          style="width: 100px;"
          @change="onFilterChange"
        >
          <el-option :value="20" label="20 筆" />
          <el-option :value="50" label="50 筆" />
          <el-option :value="100" label="100 筆" />
        </el-select>
        <el-button type="primary" size="small" :loading="isLoading" @click="fetchHistory">
          查詢
        </el-button>
      </div>
    </el-card>

    <el-table
      :data="records"
      v-loading="isLoading"
      border
      size="mini"
      stripe
      style="width: 100%;"
    >
      <el-table-column label="Email" min-width="200">
        <template #default="{ row }">
          {{ row.user && row.user.email || row.email || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="姓名" min-width="120">
        <template #default="{ row }">
          {{ row.user && row.user.name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="權限" min-width="90">
        <template #default="{ row }">
          {{ row.user && row.user.roles || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="IP 位址" min-width="140">
        <template #default="{ row }">
          {{ row.ipAddress || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="登入時間" min-width="150">
        <template #default="{ row }">
          {{ formatTime(row.issuedAt) }}
        </template>
      </el-table-column>
      <el-table-column label="到期時間" min-width="150">
        <template #default="{ row }">
          {{ formatTime(row.expiresAt) }}
        </template>
      </el-table-column>
      <el-table-column label="狀態" width="80" align="center">
        <template #default="{ row }">
          <el-tag :type="row.active ? 'success' : 'info'" size="mini">
            {{ row.active ? '有效' : '已失效' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="失效時間" min-width="150">
        <template #default="{ row }">
          {{ formatTime(row.revokedAt) }}
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top: 12px; display: flex; justify-content: flex-end;">
      <el-pagination
        :current-page="page"
        :page-size="limit"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'SessionHistory',
  data() {
    return {
      isLoading: false,
      clientList: [],
      selectedUserId: '',
      limit: 50,
      page: 1,
      total: 0,
      records: [],
    };
  },
  mounted() {
    this.fetchClientList();
    this.fetchHistory();
  },
  methods: {
    formatTime(value) {
      if (!value) return '-';
      return moment(value).format('YYYY-MM-DD HH:mm');
    },
    fetchClientList() {
      return this.$axios({
        category: 'admin',
        method: 'get',
        apiName: 'client',
      })
        .then(res => {
          this.clientList = res.data;
        })
        .catch(this.$notifyError);
    },
    fetchHistory() {
      this.isLoading = true;
      const params = { page: this.page, limit: this.limit };
      if (this.selectedUserId) params.userId = this.selectedUserId;
      return this.$axios({
        category: 'admin',
        method: 'get',
        apiName: 'sessions/history',
        params,
      })
        .then(res => {
          this.records = res.data.sessions;
          this.total = res.data.count;
        })
        .catch(this.$notifyError)
        .finally(() => {
          this.isLoading = false;
        });
    },
    onFilterChange() {
      this.page = 1;
      this.fetchHistory();
    },
    onPageChange(newPage) {
      this.page = newPage;
      this.fetchHistory();
    },
  },
};
</script>
